import { inject, injectable } from 'inversify';
import { UserBugReport } from '@Models';
import { TYPES } from '@Types';
import { UserBugReportRepository } from '@Repository/user/user-bug-report.repository';
import { CreateUserBugReportParams } from '@Components/user/user-bug-report/user-bug-report.validate';
import { Result } from '@Redux/type';
import toast from 'react-hot-toast';
import { ILoadingEntityAction } from '@Redux/ILoadingEntityAction';
import userBugReportSlice from '@Redux/reducers/user/user-bug-report.slice';
import { PayloadAction } from '@reduxjs/toolkit';

@injectable()
export class UserBugReportAction extends ILoadingEntityAction {
  @inject(TYPES.Repository.UserBugReportRepository)
  private readonly _repository!: UserBugReportRepository;

  create =
    (values: CreateUserBugReportParams, onClose: () => void): Result<void> =>
    async (dispatch) => {
      dispatch(this.areLoading(true));

      const item = {
        reasonType: values.reasonType,
        report: values.report,
        armyId: values.armyId,
        unitId: values.unitId,
        unitOptionId: values.unitOptionId,
        value: values.value,
      } satisfies UserBugReport as UserBugReport;

      const response = await this._repository.create(item);

      if (this.handleFailure(response, dispatch)) return;

      toast.success('Thx for your report! I will take a look at it.');
      if (onClose) onClose();
      dispatch(this.areLoading(false));
    };

  protected haveError(message: string): PayloadAction<string> {
    return userBugReportSlice.actions.setError(message);
  }

  protected areLoading(bool: boolean): PayloadAction<boolean> {
    return userBugReportSlice.actions.setLoading(bool);
  }
}
